import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { api } from 'constants/api';
import { ApiError, ApiResponse } from 'types/utils/api-response';
import { MutationOptions } from 'types/utils/mutation-options';
import { UserParams } from './useAddUser';

export type EditUserResponseType = {};

type EditUserParams = {
  id: string;
  data: Pick<UserParams, 'email' | 'name' | 'phone_number' | 'is_active'>;
};

export const useEditUser = (
  options?: MutationOptions<
    EditUserResponseType,
    EditUserParams,
    AxiosError<ApiError>
  >
) =>
  useMutation({
    mutationFn: async ({ id, data: userData }) => {
      const { data } = await api.patch<ApiResponse<EditUserResponseType>>(
        `/user/${id}`,
        userData
      );

      return data.data;
    },

    ...options,
  });
